import { render, staticRenderFns } from "./RightMenuTask.vue?vue&type=template&id=5c3832eb&scoped=true&"
import script from "./RightMenuTask.vue?vue&type=script&lang=js&"
export * from "./RightMenuTask.vue?vue&type=script&lang=js&"
import style0 from "./RightMenuTask.vue?vue&type=style&index=0&id=5c3832eb&prod&lang=scss&scoped=true&"
import style1 from "./RightMenuTask.vue?vue&type=style&index=1&id=5c3832eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3832eb",
  null
  
)

export default component.exports